function d(){return m(E())}var m=(e,t=document)=>Object.entries(e).reduce((r,[o,n])=>{let s=typeof n=="string"?t.getElementById(n):Array.isArray(n)?n.map(l=>t.getElementById(l)):m(n,t);return s!=null&&(r[o]=s),r},{}),a="~idMapping",E=()=>{let e=document.getElementById(a);return e?JSON.parse(e.innerHTML||""):{}};function I(e){e(d());}

export { I as init };
